import React from "react";
// ANT DESIGN COMPONENTS
import { Input } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// UTILS
import { validateIpAString, validateIpAndPortString } from "../../../utils/utils";
// INTERFACES
import { FormularyRowTextInterface } from "../../../interfaces/FormularyRow";

export default function FormularyRowText({
  record,
  text,
  value,
  inputIcon,
  placeHolder,
  formAction,
  variableName,
  itemId,
  inputValidationType,
  textLink,
  onChangeFormValue,
}: FormularyRowTextInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const getInputStatus = (textValue: string) => {
    if (inputValidationType === "ip") {
      if (!validateIpAString(textValue) && textValue !== "") {
        return "error";
      }
    } else if (inputValidationType === "ipAndPort") {
      if (!validateIpAndPortString(textValue) && textValue !== "") {
        return "error";
      }
    }
    return "";
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <>
      {record.id === "" ? (
        <Input
          addonBefore={
            inputIcon ? <FontAwesomeIcon icon={faPlus} className="generalStyles__info" /> : null
          }
          size="small"
          placeholder={placeHolder}
          value={formAction === "create" ? value : ""}
          disabled={formAction === "edit"}
          onChange={(event) => onChangeFormValue(event.currentTarget.value, variableName)}
          status={getInputStatus(value)}
        />
      ) : (
        <>
          {formAction === "edit" && record.id === itemId ? (
            <Input
              addonBefore={
                inputIcon ? <FontAwesomeIcon icon={faPen} className="generalStyles__info" /> : null
              }
              size="small"
              placeholder={placeHolder}
              value={value}
              onChange={(event: React.FormEvent<HTMLInputElement>) => {
                onChangeFormValue(event.currentTarget.value, variableName);
              }}
              status={getInputStatus(text)}
            />
          ) : (
            <div className={textLink ? "generalStyles__info" : ""}>{text}</div>
          )}
        </>
      )}
    </>
  );
}
